export default function OrtTypeIcon({ortType}) {
    const iconUrl = window.baukulturMap.getSingleIconUrl(ortType);
    if (iconUrl) {
        return <img className="ort-form__checkbox-icon" src={iconUrl} alt={`Icon ${ortType}`}/>
    }
    return '';
}